import React from 'react';
import { connect } from 'react-redux';
import { DBDecimalFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationCircumferenceDIP extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Circumference - DIP' />
                    <label className={styles.label}>DIP</label>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Index</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPINDEXR'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPINDEXL'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Middle</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPMIDDLER'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPMIDDLEL'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Ring</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPRINGR'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPRINGL'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Small</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPSMALLR'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRDIPSMALLL'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                </div>

            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged:
            (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPINDEXR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPINDEXR !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPINDEXL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPINDEXL !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPMIDDLER !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPMIDDLER !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPMIDDLEL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPMIDDLEL !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPRINGR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPRINGR !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPRINGL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPRINGL !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPSMALLR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPSMALLR !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPSMALLL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRDIPSMALLL !== null)
                ? true : false
    };
}

const connectedObservationCircumferenceDIP = connect(mapStateToProps)(ObservationCircumferenceDIP);
export { connectedObservationCircumferenceDIP as ObservationCircumferenceDIP };


